import React, { Component } from 'react'

import Navigation from '../Navigation/Navigation';

class Rewards extends Component {
  render() {
    return (
      <section id="rewards">
        <Navigation></Navigation>
        <div className="content is-center">
          <h1 className="coming-soon">Cooming Soon...</h1>
          <p>Rewards</p>
        </div>
      </section>
    )
  }
}

export default Rewards
  